import React from "react";
import { Grid, Container } from "@material-ui/core";
import BackgroundImage from "gatsby-background-image";
import Image from "./components/image";
import Heading from "./components/heading";
import Button from "./components/button";
import Toggle from "./components/toggle";
import Paragraph from "./components/paragraph";
import Divider from "../build/components/divider";
import { getVertPos, getStyles, getColSize } from "./util/getStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const components = {
  Image: Image,
  Heading: Heading,
  "Text-Editor": Paragraph,
  Button: Button,
  Divider: Divider,
  Toggle: Toggle,
};

function ucwords(text) {
  let str = text.toLowerCase();
  return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
    return s.toUpperCase();
  });
}

const ConditionalWrapper = ({ condition, withBG, noBG, children }) =>
  condition ? withBG(children) : noBG(children);

const BuildPage = (props) => {
  const elementorData = props.data;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const fullHeight = {
    height: "100%",
  };
  const autoHeight = {
    height: "auto",
  };

  return (
    <Grid container justify="center">
      {elementorData.map((row) => {
        return (
          <ConditionalWrapper
            condition={row.settings.background_image}
            withBG={(children) => (
              <Grid
                item
                container
                sm={12}
                spacing={2}
                id={row.settings._element_id || ""}
                xs={12}
                style={getStyles(row.settings)}
              >
                <BackgroundImage
                  fluid={row.settings.background_image.fluid}
                  style={{
                    height: "100%",
                    minHeight: 400,
                    width: "100%",
                    display: "flex",
                    flexGrow: 0,
                    maxWidth: "100%",
                    flexBasis: "100%",
                    flexWrap: "wrap",
                    alignItems: getVertPos(row.settings.column_position),
                  }}
                  Tag="div"
                >
                  <Container>
                    <Grid
                      item
                      container
                      xs={12}
                      style={getStyles(row.settings)}
                      justify={row.settings.align}
                    >
                      {children}
                    </Grid>
                  </Container>
                </BackgroundImage>
              </Grid>
            )}
            noBG={(children) => {
              return (
                <Container>
                  <Grid
                    item
                    container
                    sm={12}
                    xs={12}
                    style={matches ? autoHeight : fullHeight}
                    id={row.settings._element_id || ""}
                  >
                    <Grid
                      item
                      container
                      spacing={2}
                      xs={12}
                      justify={row.settings.align}
                      alignItems={getVertPos(row.settings.content_position)}
                      style={getStyles(row.settings)}
                    >
                      {children}
                    </Grid>
                  </Grid>
                </Container>
              );
            }}
            key={row.id}
          >
            <React.Fragment>
              {row.elements.map((column) => {
                return (
                  <ConditionalWrapper
                    condition={column.settings.background_image}
                    withBG={(children) => (
                      <Grid
                        item
                        container
                        sm={Math.round(
                          12 / (100 / getColSize(column.settings))
                        )}
                        xs={12}
                        style={matches ? autoHeight : fullHeight}
                      >
                        <BackgroundImage
                          fluid={column.settings.background_image.fluid}
                          style={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexGrow: 0,
                            maxWidth: "100%",
                            flexBasis: "100%",
                            flexWrap: "wrap",
                            alignItems: getVertPos(
                              column.settings.content_position
                            ),
                          }}
                          Tag="div"
                        >
                          <Grid
                            item
                            container
                            xs={12}
                            style={getStyles(column.settings)}
                            justify={column.settings.align}
                          >
                            {children}
                          </Grid>
                        </BackgroundImage>
                      </Grid>
                    )}
                    noBG={(children) => (
                      <Grid
                        item
                        container
                        sm={Math.round(
                          12 / (100 / getColSize(column.settings))
                        )}
                        xs={12}
                        style={matches ? autoHeight : fullHeight}
                      >
                        <Grid
                          item
                          container
                          xs={12}
                          justify={column.settings.align}
                          alignItems={getVertPos(
                            column.settings.content_position
                          )}
                          style={getStyles(column.settings)}
                        >
                          {children}
                        </Grid>
                      </Grid>
                    )}
                    key={column.id}
                  >
                    <React.Fragment>
                      {column.elements.map((widget) => {
                        if (components[ucwords(widget.widgetType)]) {
                          return (
                            <div
                              style={{
                                padding:
                                  column.settings.space_between_widgets || 0,
                                width: "100%",
                                textAlign: widget.settings.align,
                              }}
                              key={widget.id}
                            >
                              {React.createElement(
                                components[ucwords(widget.widgetType)],
                                {
                                  ...widget.settings,
                                  key: widget.id,
                                }
                              )}
                            </div>
                          );
                        } else {
                          return false;
                        }
                      })}
                    </React.Fragment>
                  </ConditionalWrapper>
                );
              })}
            </React.Fragment>
          </ConditionalWrapper>
        );
      })}
    </Grid>
  );
};
export default BuildPage;
